'use strict';
document.addEventListener("DOMContentLoaded", function(){
	const lazyEl = document.querySelectorAll('.lazy-load');
	let i;

	for (i = 0; i < lazyEl.length; ++i) {
		
		let thisObj = lazyEl[i];
		const newSrc = thisObj.getAttribute('data-bgsrc');
		const downloadImage = new Image();

		downloadImage.onload = function(){
			if (thisObj.tagName === 'IMG') {
				thisObj.setAttribute('src', newSrc);
				thisObj.classList.add('lazyLoaded');
			} else {
				thisObj.style.backgroundImage = "url(" + newSrc + ")";
				thisObj.classList.add('lazyLoaded');
			}
		};
		
		downloadImage.src = newSrc;
			
	}
	
});